import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SelectOption } from '../config/ci-options.config';

let uid = 0;

@Component({
  selector: 'ui-select',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule],
  templateUrl: './ui-select.component.html',
})
export class UiSelectComponent {
  readonly control = input.required<FormControl<any>>();
  readonly label = input.required<string>();
  readonly options = input.required<readonly SelectOption[]>();
  readonly placeholder = input('Select');
  readonly hint = input('');
  readonly required = input(false);

  readonly id = `ci-sel-${uid++}`;

  readonly invalid = computed(() => {
    const c = this.control();
    return c.invalid && (c.touched || c.dirty);
  });
}
